import {useTranslation} from '@aboutyou/i18n';
import {useBasketRoute, useHistory} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {GenericIconName, useValueAfterHydration} from '@aboutyou/ui-components';
import {
  useBasketContainsCampaignOrCouponItems,
  useBasketCount,
} from '@aboutyou/user';
import React, {useMemo} from 'react';
import {useSelectedDiscountColor} from '../../Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {IconMetaNavigationItem} from './IconMetaNavigationItem';

export const IconMetaNavigationItemBasket: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({onClick}) => {
  const {t} = useTranslation();
  // TODO: remove the usage of `useValueAfterHydration` https://aboutyou.atlassian.net/browse/ASFE-11723
  const basketCount = useValueAfterHydration(useBasketCount());
  const selectedDiscountColor = useValueAfterHydration(
    useSelectedDiscountColor(),
  );
  const basketContainsSaleItems = useValueAfterHydration(
    useBasketContainsCampaignOrCouponItems(),
  );

  const trackFeature = useTrackFeature();
  const basketRoute = useBasketRoute();
  const history = useHistory();

  const basketSaleIndication = useMemo(() => {
    return selectedDiscountColor && basketContainsSaleItems
      ? {color: selectedDiscountColor}
      : undefined;
  }, [selectedDiscountColor, basketContainsSaleItems]);

  return (
    <IconMetaNavigationItem
      dataTestId="Basket"
      icon={GenericIconName.NavHeaderBasket}
      label={t('Basket')}
      count={basketCount}
      badgeOffset={{
        right: 3,
        top: 3,
      }}
      saleIndication={basketSaleIndication}
      onClick={event => {
        onClick(event);
        trackFeature({eventType: 'click', label: 'basket_icon'});
        history.push(basketRoute);
      }}
    />
  );
};
